// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dP6DBDIww2UVD_CrdYqJ{max-height:calc(100vh - 120px);margin-top:1px;padding:7px;position:relative;overflow-x:hidden;overflow-y:auto}._8aRXVKxx_E7V0ulnmpo{color:var(--content-primary-tertiary);flex-direction:column;justify-content:center;align-items:center;margin-top:35vh;display:flex}._8aRXVKxx_E7V0ulnmpo p{font-size:14px;line-height:20px}.ndYusS0Wy8dmJwegkBZp{text-align:center;color:var(--content-primary-tertiary);justify-content:center;padding:calc(50vh - 141px) 20px 8px;display:flex}.JrPk7cZFQwXXxO6tpzEC{margin-bottom:12px}.T7WspFid7JAnKcMg_oUw{margin:0;padding:0;list-style:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"callsFiltersInfo": `dP6DBDIww2UVD_CrdYqJ`,
	"listStatus": `_8aRXVKxx_E7V0ulnmpo`,
	"emptyCalls": `ndYusS0Wy8dmJwegkBZp`,
	"filterGroup": `JrPk7cZFQwXXxO6tpzEC`,
	"filters": `T7WspFid7JAnKcMg_oUw`
};
export default ___CSS_LOADER_EXPORT___;
